import { ca } from '@cian/analytics';

import { EDeviceType } from '../../types/device';
import { IFavoriteEntity } from '../../types/results';
import { EOfferType, getCustomUrl, getPageNumber } from '../../utils/trackings';

interface IParameters {
  offer: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
  isEarlyAccess?: boolean;
}

interface IBlockedParameters extends IParameters {
  blockType: string;
}

export function trackClick({ offer, position, total, deviceType, isEarlyAccess = false }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Favorite',
    action: 'send_message',
    label: getCustomUrl(offer),
    page: {
      pageType: 'ListingFavorites',
      listingType: 'list',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        owner_id: offer.agentInfo?.id,
        is_early_access: isEarlyAccess,
      },
    },
    products: [
      {
        id: offer.entityId,
        offerType: EOfferType.Offer,
        position,
        published: offer.status === 'published',
      },
    ],
  });
}

export function trackClickBlocked({ offer, position, total, deviceType, blockType }: IBlockedParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Favorite',
    action: 'send_message_blocked_early_access',
    label: getCustomUrl(offer),
    page: {
      pageType: 'ListingFavorites',
      listingType: 'list',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        owner_id: offer.agentInfo?.id,
        block_type: blockType,
      },
    },
    products: [
      {
        id: offer.entityId,
        offerType: EOfferType.Offer,
        position,
        published: offer.status === 'published',
      },
    ],
  });
}
